import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { useLanguage } from '@/hooks/useLanguage';
import { tx } from '@/utils/i18n';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  useLanguage();
  const { resolvedTheme, setMode } = useTheme();
  const isDark = resolvedTheme === 'dark';
  const label = tx(isDark ? 'Modo escuro' : 'Modo claro');
  const Icon = isDark ? Moon : Sun;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={label}
            aria-pressed={isDark}
            onClick={() => setMode(isDark ? 'light' : 'dark')}
            className={cn(
              'theme-toggle inline-flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-[10px] text-muted-foreground transition-colors hover:text-[#315FD5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              compact && 'h-9 w-9'
            )}
          >
            <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.8} />
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
